if (!window.cartStateRestoreInitialized) {
  window.cartStateRestoreInitialized = true;

  (() => {
    const parseHTML = (html) =>
      new DOMParser().parseFromString(html, 'text/html');

    const refreshCartIcon = (html) => {
      const target = document.getElementById('cart-icon-bubble');
      const source = parseHTML(html).getElementById('cart-icon-bubble');
      if (target && source) target.replaceChildren(...source.childNodes);
    };

    const refreshCartDrawer = (html) => {
      const fresh = parseHTML(html);
      const target = document.getElementById('CartDrawer');
      const source = fresh.getElementById('CartDrawer');
      if (!target || !source) return;

      target.innerHTML = source.innerHTML;
      target
        .closest('.js-drawer')
        ?.classList.toggle(
          'is-empty',
          !!fresh.querySelector('.js-drawer')?.classList.contains('is-empty')
        );
    };

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;

      if (document.getElementById('main-cart-items')) {
        window.location.reload();
        return;
      }

      const drawerSectionId = document.querySelector('cart-drawer')?.dataset.id;
      const sections = drawerSectionId
        ? ['cart-icon-bubble', drawerSectionId]
        : ['cart-icon-bubble'];

      fetch(`${window.routes.cart_url}?sections=${sections.join(',')}`)
        .then((response) => response.json())
        .then((rendered) => {
          refreshCartIcon(rendered['cart-icon-bubble']);
          if (drawerSectionId) refreshCartDrawer(rendered[drawerSectionId]);
        })
        .catch(console.error);
    });
  })();
}
